import React, { Component } from 'react';
import EmptyImage from './EmptyImage';
import { PATHS } from '../../common/constants';
import { Link } from 'react-router-dom';
import './HomeOwnerDashboard.scss';

class MaintainanceList extends Component {

    render() {
        const { data,currentUserSuite } = this.props;
        return (
            <div className='homeDasboard__mainTile'>
                <div style={{ padding: 20 }}>
                    <label className='homeDasboard__title'>MAINTENANCE REMINDERS</label>
                    {data && data.length > 0 ?
                        <div className='homeDasboard__tile'>
                            <div style={{ display: 'flex' }}>
                                <div style={{ width: '30%' }}>
                                    <label className='homeDasboard__tableItem'>Asset</label>
                                </div>
                                <div style={{ width: '70%' }}>
                                    <label className='homeDasboard__tableItem'>Description</label>
                                </div>
                            </div>
                            <div className='homeDasboard__list'>
                                {data && data.length > 0 ? data.map((item, i) => {
                                    let maintenance = JSON.parse(item.data)                                    
                                    return (
                                        <div className='homeDasboard__table' >
                                            <Link
                                            to={{
                                                // pathname:PATHS.ASSETS_VIEW.replace(':id', item.assetId),
                                                pathname:PATHS.ASSETS_VIEW.replace(':id', item.areaId+'&'+item.assetId),
                                                state:{ asset:{id: item.assetId,
                                                    item: {id: item.itemId}},
                                                suite:{id: item.unitId, number: item.suiteNumber},property:{ id: item.propertyId }, activeTab: 1 }
                                            }}
                                            >
                                                <div style={{ display: 'flex' }}>

                                                    <div style={{ width: '30%' }}>
                                                        <div className='homeDasboard__activityText'>{item.itemName}</div>
                                                        <div className='homeDasboard__role'>{item.makeName}</div>
                                                        <div className='homeDasboard__role'>{item.model ? item.model : ''}</div>
                                                    </div>
                                                    <div style={{ width: '70%' }}>
                                                        <div>
                                                            <label className='homeDasboard__role'>{<div dangerouslySetInnerHTML={{__html: maintenance.body}} />}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>

                                        </div>
                                    )
                                }) : null}
                                <Link
                                    to={{
                                        pathname: PATHS.SUITES_VIEW.replace(':id', currentUserSuite.propertyId + "&" + currentUserSuite.id),
                                        state: { suite: { id: currentUserSuite.id }, property: { id: currentUserSuite.propertyId }, activeTab: 4 }
                                    }}
                                >
                                    <div className='homeDasboard__viewAll' style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: 5 }}>MORE</div>
                                </Link>
                            </div>
                        </div>
                        :
                        <EmptyImage
                            width={200}
                            height={100}
                            text='You have no Maintenance Reminders.'
                            image={"/assets/empty/suites.svg"}
                        />
                    }
                </div>
            </div>
        )
    }
}
export default MaintainanceList